import {t} from '../../localization';

export const getFormattedData = (data?: string | number | boolean): string => {
  if (data === undefined) {
    return '';
  }
  if (typeof data === 'boolean') {
    return data ? t('general.true') : t('general.false');
  }
  return data.toString();
};
